/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="862" height="22" {...props}>
    <circle cx="11" cy="11" r="11" fill="#05F"></circle>
    <circle cx="431" cy="11" r="11" fill="#05F"></circle>
    <circle cx="53" cy="11" r="11" fill="#05F"></circle>
    <circle cx="473" cy="11" r="11" fill="#05F"></circle>
    <circle cx="95" cy="11" r="11" fill="#05F"></circle>
    <circle cx="515" cy="11" r="11" fill="#05F"></circle>
    <circle cx="137" cy="11" r="11" fill="#05F"></circle>
    <circle cx="557" cy="11" r="11" fill="#05F"></circle>
    <circle cx="179" cy="11" r="11" fill="#05F"></circle>
    <circle cx="599" cy="11" r="11" fill="#05F"></circle>
    <circle cx="221" cy="11" r="11" fill="#05F"></circle>
    <circle cx="641" cy="11" r="11" fill="#05F"></circle>
    <circle cx="263" cy="11" r="11" fill="#05F"></circle>
    <circle cx="683" cy="11" r="11" fill="#05F"></circle>
    <circle cx="305" cy="11" r="11" fill="#05F"></circle>
    <circle cx="725" cy="11" r="11" fill="#05F"></circle>
    <circle cx="347" cy="11" r="11" fill="#05F"></circle>
    <circle cx="767" cy="11" r="11" fill="#05F"></circle>
    <circle cx="389" cy="11" r="11" fill="#05F"></circle>
    <circle cx="809" cy="11" r="11" fill="#05F"></circle>
    <circle cx="851" cy="11" r="11" fill="#05F"></circle>
  </Svg>
)

export default Icon
